module.exports = __webpack_public_path__ + "static/media/morse-code.263fb249.svg";